<template>
  <div ref="color-picker" class="color-picker">
      <button @click="handleClick" class="color-picker-btn" :style="{backgroundColor: value }"></button>
      <slider-picker v-if="isShowPicker" class="mt-5" v-model="color" />
  </div>
</template>

<script>
import { Chrome } from 'vue-color'
export default {
    name: 'ColorPicker',
    components: {
        'slider-picker': Chrome,
    },
    watch:{
        color() {
           this.$emit('input', this.color.hex)
        },
    },
    props: {
        value: String,
    },
    data() {
        return {
            color: '#000',
            isShowPicker: false,
        }
    },
    mounted() {
        document.addEventListener('click', this.handleOutsideClick)
        document.addEventListener('touchstart', this.handleOutsideClick)
    },
    destroyed() {
        document.removeEventListener('click', this.handleOutsideClick)
        document.removeEventListener('touchstart', this.handleOutsideClick)
    },
    methods: {
        handleOutsideClick(e) {
            if ( this.$refs['color-picker'] && !this.$refs['color-picker'].contains(e.target) && this.$refs['color-picker'] != e.target) {
                this.isShowPicker = false
            }
        },
        handleClick() {
            this.isShowPicker = !this.isShowPicker
        }
    }
}
</script>

<style lang="scss">
.color-picker{
    display: inline-block;
    position: relative;
    .vc-chrome{
        position: absolute;
        top: 0px;
        z-index: 10;
    }
    .color-picker-btn{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        outline: none;
        padding: 0;
        border: 1px solid #ddd;
    }
} 
</style>